<script>
export default {
  name: 'Description',
  props: {
    direction: {
      type: String,
      default: 'right',
    },
    icon: {
      type: String,
      default: 'mdi-help-circle',
    },
    iconColor: {
      type: String,
      default: '#000000',
    },
    descriptionText: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '#',
    },
  },
}
</script>

<template>
  <div>
    <v-tooltip :right="direction">
      <template #activator="{ on, attrs }">
        <a class="d-flex" style="text-decoration: none" target="_blank" :href="link">
          <v-icon :color="iconColor" size="20" v-bind="attrs" v-on="on">{{ icon }}</v-icon>
        </a>
      </template>
      <span>{{ descriptionText }}</span>
    </v-tooltip>
  </div>
</template>
